interface TrackArgs {
  event: string;
  properties?: unknown;
  options?: unknown;
  callback?: () => void;
}

export const sendEventToSegment = ({ event, properties, options, callback }: TrackArgs) => {
  if (window?.analytics?.track) {
    window.analytics.track(event, properties, options, callback);
  } else {
    console.error('window.analytics.track is not defined');
    // eslint-disable-next-line
    callback?.();
  }
};
